export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to rebuild my barre work every single week. Now I open the volume, choose the sequence that fits the level, and my planning is done before dinner. My classes finally feel like they belong to one plan.',
    author: 'Emily R.',
    role: 'Ballet Teacher',
    location: 'Denver, Colorado',
  },
  {
    quote:
      'Teaching a mixed group used to be the hardest part of my week. With the age and level structure I can run one class and adapt it on the spot — the little ones and the older girls both get what they need.',
    author: 'Sarah M.',
    role: 'Ballet Instructor',
    location: 'Toronto, Ontario',
  },
  {
    quote:
      'What changed for me is knowing what comes next. Every week builds on the last one instead of repeating it, and I can actually see my students progressing — so can their parents.',
    author: 'Jessica T.',
    role: 'Studio Owner & Ballet Teacher',
    location: 'Portland, Oregon',
  },
]
